import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getHistoricalNfts } from '../helpers/calls';
import { IHistorical } from '../types/IHistorical';
import { onChainProvider } from '../types/onChainProvider';
import { useWeb3Context } from './useWeb3Context';


function useHistorical() {
    const { provider, address }: onChainProvider = useWeb3Context();
    const [historicalNfts, setHistoricalNfts] = useState<IHistorical[]>([]);
    const [historicalNftsIsLoading, setHistoricalNftsIsLoading] = useState(true);
    const [balanceIsLoading, setBalanceIsLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const { hash } = useLocation();

    const getNftByTokenParam = (h: any) => {
        const token = hash.replace('#', '');
        const historicals = h.filter((nft: any) => {
            const tokenName: string = nft.token.split(' ').join('-').toLowerCase();
            return tokenName === token || (nft.customUri && nft.customUri.length > 0 && nft.customUri === token);
        });
        if (historicals.length > 0) return historicals[0];
        else return { token: null };
    }

    useEffect(() => {
        const getHistoricals = async () => {
            const historicalInfo = await getHistoricalNfts();
            let count: number = 0;
            let totalCount: number = 0;
            let countBalance: number = 0;
            if (historicalInfo) {
                historicalInfo.forEach(async (nfts: IHistorical) => {
                    if (provider && address) {
                        // Hold a count with how many times the balance has been set
                        countBalance++;
                        // Get contract info and get the balances of the nfts based on the connected address
                        const contract = new ethers.Contract(nfts.contractAddress as string, nfts.contractAbi, provider);
                        const balanceOf = await contract.balanceOf(address);
                        let balanceOfReadable: number = 0;
                        if (!nfts.isNFT && nfts.decimals > 0) {
                            balanceOfReadable = new BigNumber(balanceOf.toString()).div(nfts.decimals).toNumber()
                        } else {
                            balanceOfReadable = Number(balanceOf.toString())
                        }

                        nfts.balance = balanceOfReadable;
                        const nftByTokenParam = getNftByTokenParam(historicalInfo);
                        if (nftByTokenParam && nftByTokenParam.token !== null) {
                            totalCount = nftByTokenParam.balance;
                        } else {
                            totalCount += balanceOfReadable;
                        }

                        // Set balance is loading to false when loading all the balances
                        if (countBalance >= historicalInfo.length) setBalanceIsLoading(false)
                    }

                    count++;
                    if (count >= historicalInfo.length) {
                        setTotal(totalCount);
                        setHistoricalNfts(historicalInfo);
                        // setTimeout(() => setHistoricalNftsIsLoading(false), 500) // Data is to quick so we add a timeout
                        setHistoricalNftsIsLoading(false)
                    }
                });
            }
        }

        getHistoricals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address])

    return {
        historicalNfts,
        getNftByTokenParam,
        total,
        balanceIsLoading,
        historicalNftsIsLoading
    }
}

export default useHistorical;